import React, { useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextArea from "../../Components/Reusable/CustomTextArea";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";
import FaqCategoryService from "../../Services/FaqService";

const AddFAQ = () => {
  const [faqCategory, setFaqCategory] = useState([]);
  const [faqEdit, setFaqEdit] = useState({ ...useLocation().state });

  const navigate = useNavigate();

  const Validations = yup.object().shape({
    faq_category_id: validationRegex.required,
    question: validationRegex.required,
    answer: validationRegex.required,
  });
  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    formState: { errors: errors },
    getValues: getValues,
    reset: reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      faq_category_id: faqEdit?.faq_category_id || "",
      question: faqEdit?.question || "",
      answer: faqEdit?.answer || "",
    },
  });

  const addFaq = async (faqData) => {
    try {
      const response = await FaqCategoryService.addFaq(
        faqEdit.faq_id || "",
        faqData.faq_category_id,
        faqData.question,
        faqData.answer
      );
      toast.success(response.message);
      navigate(RoutesPath.viewFaq);
    } catch (error) {
      handleApiErrors(error);
      toast.error("Failed to add faq,s . Please try again later.");
    }
  };

  const onSubmit = (data) => {
    addFaq(data);
  };

  const getAllcategory = async () => {
    try {
      const response =
        await FaqCategoryService.getAllFaqCategoryWithoutPagination();
      setFaqCategory(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  useEffect(() => {
    if (faqEdit) {
      setValues("faq_category_id", faqEdit.faq_category_id || ""); // Update form values when faqEdit changes
      setValues("question", faqEdit.question || "");
      setValues("answer", faqEdit.answer || "");
    }
  }, [faqEdit, setValues]);

  useEffect(() => {
    getAllcategory();
  }, []);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">FAQ’s</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">FAQ’S</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {faqEdit.faq_category_id ? "Edit" : ""} FAQ’S
            </h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-5">
              {faqEdit.length != 0 && (
                <CustomDropDown
                  labelTitle="Category"
                  placeholder="Select"
                  name="faq_category_id"
                  id="faq_category_id"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  register={register}
                  showMandatory={true}
                  setValue={setValues}
                  showError={errors?.faq_category_id}
                  errorMessage={errors?.faq_category_id?.message}
                  options={faqCategory?.map((e) => {
                    return {
                      value: e.faq_category_id,
                      label: e.faqCategoryName,
                    };
                  })}
                  defaultOption={{
                    value: faqEdit?.faq_category_id,
                    label: faqEdit?.faqCategoryName,
                  }}
                />
              )}
              <CustomTextArea
                labelTitle="Question"
                placeholder="Type question here..."
                name="question"
                id="question"
                additionalClasses="profile_edit qustion"
                setValue={setValues}
                inputType={InputType.text}
                showMandatory={true}
                register={register}
                showError={errors?.question}
                errorMessage={errors?.question?.message}
              />
              <CustomTextArea
                labelTitle="Answer"
                placeholder="Type question here..."
                name="answer"
                id="answer"
                additionalClasses="profile_edit qustion"
                setValue={setValues}
                inputType={InputType.text}
                showMandatory={true}
                register={register}
                showError={errors?.answer}
                errorMessage={errors?.answer?.message}
              />

              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={faqEdit?.faq_id ? "Update" : "Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFAQ;
